module.exports = " \r\n  \r\n<div   id=\"map\">\r\n\r\n</div>    \r\n            \r\n \r\n\r\n             "


//////////////////
// WEBPACK FOOTER
// /Neptune/buildsJenkins/lrm_grandPublic/LRM-GP/LrGrandPublic/src/main/LRM-web/src/app/map/map.component.html
// module id = ../../../../../src/app/map/map.component.html
// module chunks = main